export * from './input-group-component-config.interface';
